import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProviderStripePaymentStatus, getProviderStripeBankAccount, getProviderStripePayoutes } from "../slice/providerStripePaymentSlice";

const ProviderPanelStripeSetting = () => {
  const dispatch = useDispatch();
  const [stripeUrl, setStripeUrl] = useState("");
  const [stripeStatus, setStripeStatus] = useState({
    charges_enabled: false,
    details_submitted: false,
    payouts_enabled: false,
  });
const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
const [show, setShow] = useState(false);
const { providerStripePaymentSetting, providerStripeBankAcc, providerStripePayouts } = useSelector((state) => state.providerStripePaymentSetting);
const [expandedBank, setExpandedBank] = useState(null);
const [payouts, setPayouts] = useState({}); // store payouts by bankId

const token = localStorage.getItem("provider_access_token");
    
      useEffect(() => {
        dispatch(getProviderStripePaymentStatus(token));
        dispatch(getProviderStripeBankAccount(token));
        // dispatch(getProviderStripePayoutes(token));
      }, [dispatch, token]);

      console.log("providerStripePaymentSetting", providerStripePaymentSetting);
      console.log("providerStripeBankAcc", providerStripeBankAcc);
      // console.log("providerStripePayouts", providerStripePayouts);

      const sortedBankData = [...providerStripeBankAcc].sort((a, b) => {
        if (sortConfig.column === null) return 0;

        const key = sortConfig.column;

        const valA = a[key] ?? "";
        const valB = b[key] ?? "";

        if (!isNaN(valA) && !isNaN(valB)) {
          return sortConfig.direction === "asc"
              ? valA - valB
              : valB - valA;
        } else {
          return sortConfig.direction === "asc"
              ? valA.toString().localeCompare(valB.toString())
              : valB.toString().localeCompare(valA.toString());
        }
    });

    const toggleShow = () => {
      setShow(prev => !prev);
    };

    const toggleBank = async (bankId) => {
      if (expandedBank === bankId) {
        setExpandedBank(null); // collapse
      } else {
        setExpandedBank(bankId);
  
          const res = await dispatch(getProviderStripePayoutes({ token, bankId }));
          console.log('data data',res.payload.payouts.data);
          
          setPayouts(prev => ({ ...prev, [bankId]: res.payload.payouts.data }));
          console.log();
      }
    };

    const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };

  // Fetch Stripe URL for account setup
  const fetchStripeUrl = async () => {
    const token = localStorage.getItem("provider_access_token");

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/provider/genrate-stripe-acc`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Stripe URL");
      }

      const data = await response.json();
      setStripeUrl(data.url);
      window.open(data.url, "_blank");
    } catch (error) {
      console.error("Error fetching Stripe URL:", error);
    }
  };

  // Open the URL directly or fetch and open
  const navigateStripeRegister = () => {
    if (stripeUrl) {
      window.open(stripeUrl, "_blank");
    } else {
      fetchStripeUrl();
    }
  };

      

  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            Stripe Setting
          </h4>

          {/* <div className="form-section mt-3 d-flex justify-content-center">
            <button className="btn btn-custom-primary w-50" onClick={navigateStripeRegister}>
              Stripe Account Setup
            </button>
          </div> */}
          {!providerStripePaymentSetting?.charges_enabled &&

            !providerStripePaymentSetting?.payouts_enabled &&

            !providerStripePaymentSetting?.details_submitted && (
            <div className="form-section mt-3 d-flex justify-content-center">
            <button className="btn btn-custom-primary w-50" onClick={navigateStripeRegister}>

                  Stripe Account Setup
            </button>
            </div>

          )}

 

          {/* Stripe Status Section */}
          {providerStripePaymentSetting && (
            <div className="mt-4 border p-3 rounded bg-light">
              <h5 className="mb-3 fw-bold">Stripe Account Status</h5>
              <ul className="list-unstyled mb-0">
                <li className="mb-2">
                  <strong>Charges Enabled:</strong>{" "}
                  <span className={providerStripePaymentSetting.charges_enabled ? "text-success" : "text-danger"}>
                    {providerStripePaymentSetting.charges_enabled ? "Yes" : "No"}
                  </span>
                </li>
                <li className="mb-2">
                  <strong>Payouts Enabled:</strong>{" "}
                  <span className={providerStripePaymentSetting.payouts_enabled ? "text-success" : "text-danger"}>
                    {providerStripePaymentSetting.payouts_enabled ? "Yes" : "No"}
                  </span>
                </li>
                <li className="mb-2">
                  <strong>Details Submitted:</strong>{" "}
                  <span className={providerStripePaymentSetting.details_submitted ? "text-success" : "text-danger"}>
                    {providerStripePaymentSetting.details_submitted ? "Yes" : "No"}
                  </span>
                </li>
              </ul>
            </div>
          )}

            <h4 className="font-weight-bold text-primary font-size-30 mb-3 pb-3 line-hight-2 border-bottom mt-5 montserrat d-flex align-items-center">
                My Bank Details
            </h4>
            {/* <div className="table-responsive">
                <table className="table table-striped table-bordered align-middle text-muted" id="servicesTable">
                  <thead>
                      <tr>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("bank_name")}>Bank Name<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("last4")}>last4 <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("routing_number")}>Routing Number<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("country")}>Country<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("currency")}>Currency<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold" onClick={() => handleSort("status")}>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        <th width="" className="font-weight-semibold">Action<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                      </tr>
                  </thead>
                  <tbody>
                      {sortedBankData.length > 0 ? (
                        sortedBankData.map((acc, index) => {
                            

                            return (
                            <tr key={index}>
                              <td>{acc.bank_name || '—'}</td>
                              <td>{acc.last4 || '—'}</td>
                              <td>{acc.routing_number}</td>
                              <td>{acc.country || '—'}</td>
                              <td>{acc.currency || '—'}</td>
                              <td>{acc.status}</td>
                              <td>{'----'}</td>
                              
                            </tr>
                            );
                        })
                      ) : (
                        <tr>
                            <td colSpan="7" className="text-center">No data found.</td>
                        </tr>
                      )}
                  </tbody>
                </table>
            </div> */}

            {/* <div className="container-str">
              <h2>Bank Payouts</h2>
              <div className="bank-list">
                {sortedBankData.map(bank => (
                  <div key={bank.id} className="bank-item">
                    <div className="bank-header" onClick={() => toggleBank(bank.id)}>
                      <span>{bank.bank_name} ({bank.last4})</span>
                      <span>{expandedBank === bank.id ? '▲' : '▼'}</span>
                    </div>
                    {expandedBank === bank.id && (
                      <div className="payout-list">
                        {payouts[bank.id] && payouts[bank.id].length > 0 ? (
                          payouts[bank.id].map(p => (
                            <div key={p.id} className="payout-item">
                              <div><b>Amount:</b> {p.amount} {p.currency}</div>
                              <div><b>Status:</b> {p.status}</div>
                              <div><b>Date:</b> {new Date(p.created_at).toLocaleString()}</div>
                            </div>
                          ))
                        ) : (
                          <p>No payouts found</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div> */}

            
            
            {sortedBankData.map(bank => (
              <section className="content">
                <div className="card card-body p-3 bg-light">
                  <div className="row">
                    {/* Load ID */}
                    <div className="col-md-3">
                      
                        <div className="panel panel-default bg-white p-2 px-3 rounded-pill">
                          <label htmlFor="control-label">
                          { bank.bank_name }
                          </label>
                        </div>
                      
                    </div>

                    {/* Driver Info */}
                    <div className="col-md-2">
                      <div className="panel panel-default bg-white p-2 px-3 rounded-pill">
                        <div className="panel-body">
                          <b>last4</b> { bank.last4 }
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="panel panel-default bg-white p-2 px-3 rounded-pill">
                        <div className="panel-body">
                          <b>routing_number</b> { bank.routing_number }
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="panel panel-default bg-white p-2 px-3 rounded-pill">
                        <div className="panel-body">
                          <b>status</b> { bank.status }
                        </div>
                      </div>
                    </div>

                    {/* Toggle Button */}
                    <div className="col-md-2">
                      <button
                        className="btn btn-primary"
                        // onClick={toggleShow}
                        onClick={() => toggleBank(bank.id)}
                      >
                        {show ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  {/* Hidden Content */}
                  {expandedBank === bank.id && (
                    <table className="table table-striped table-bordered align-middle text-muted" id="servicesTable">
                    <thead>
                        <tr>
                          <th width="" className="font-weight-semibold" onClick={() => handleSort("bank_name")}>Payouts ID<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                          <th width="" className="font-weight-semibold" onClick={() => handleSort("last4")}>Source Type <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                          <th width="" className="font-weight-semibold" onClick={() => handleSort("routing_number")}>Amount<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                          <th width="" className="font-weight-semibold" onClick={() => handleSort("status")}>Status <span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                          <th width="" className="font-weight-semibold">Date<span className="d-grid table-grad"><i className="fa fa-sort-asc sort-icon"></i><i className="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                        </tr>
                    </thead>
                    <tbody>

                    {payouts[bank.id] && payouts[bank.id].length > 0 ? (
                        payouts[bank.id].map(p => (
                            
                              <tr key={p.id}>
                                <td>{p.id || '—'}</td>
                                <td>{p.source_type || '—'}</td>
                                <td>{p.amount / 100} {p.currency}</td>
                                <td>{p.status}</td>
                                <td>{p.created || '—'}</td>
                              </tr>
                        ))
                      ) : (
                        <tr>
                            <td colSpan="7" className="text-center">No data found.</td>
                        </tr>
                      )}

                  </tbody>
                  </table>

                  )}

                      
                       
                      
                          
                        
                      
                </div>
              </section>
            ))}
            
        </div>
      </div>
    </>
  );
};

export default ProviderPanelStripeSetting;
